import React from 'react';
import { Box, Drawer, IconButton, Typography } from '@mui/material';
import { bool, func } from 'prop-types';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';

// Components
import { useTheme } from '@mui/material/styles';
import FilterPopover from '../filter-popover/FilterPopover.connector';

// Styles
import { cancelButtonStyles, filterDrawerStyles, topBarStyles } from './MobileFilterDrawer.styles';

const MobileFilterDrawer = ({ mobileFilterDrawerOpen, setMobileFilterDrawerOpen }) => {
  const theme = useTheme();
  return (
    <Drawer
      anchor="right"
      onClose={() => setMobileFilterDrawerOpen(false)}
      open={mobileFilterDrawerOpen}
      slotProps={{
        backdrop: { invisible: true },
        paper: { sx: filterDrawerStyles },
      }}
    >
      <Box alignItems="center" display="flex" justifyContent="space-between" sx={topBarStyles}>
        <Typography variant="h5">Filters</Typography>
        <IconButton
          onClick={() => setMobileFilterDrawerOpen(false)}
          size="large"
          sx={cancelButtonStyles(theme)}
        >
          <CloseRoundedIcon />
        </IconButton>
      </Box>
      <FilterPopover />
    </Drawer>
  );
};

MobileFilterDrawer.propTypes = {
  mobileFilterDrawerOpen: bool.isRequired,
  setMobileFilterDrawerOpen: func.isRequired,
};

export default MobileFilterDrawer;
